export enum Chain {
  ETH = "eth",
  ARB = "arb",
  POLYGON = "polygon",
  OPT = "opt",
  SOLANA = "solana",
  ASTAR = "astar",
  POLYGONZKEVM = "polygonzkevm",
  STARKNET = "starknet",
  BASE = "base",
  ZKSYNC = "zksync",
  ZORA = "zora",
  FRAX = "frax",
  BNB = "bnb",
}

export enum Network {
  ETH_MAINNET = 0,
  ETH_ROPSTEN = 1,
  ETH_RINKEBY = 2,
  ETH_KOVAN = 3,
  ETH_GOERLI = 4,
  ETH_SEPOLIA = 5,
  ARB_MAINNET = 201,
  ARB_RINKEBY = 203,
  ARB_GOERLI = 205,
  ARB_SEPOLIA = 206,
  POLYGON_MAINNET = 401,
  POLYGON_MUMBAI = 406,
  POLYGON_AMOY = 407,
  OPT_MAINNET = 501,
  OPT_KOVAN = 504,
  OPT_GOERLI = 505,
  OPT_SEPOLIA = 506,
  SOLANA_MAINNET = 701,
  SOLANA_DEVNET = 703,
  ASTAR_MAINNET = 801,
  POLYGONZKEVM_MAINNET = 901,
  POLYGONZKEVM_TESTNET = 902,
  POLYGONZKEVM_CARDONA = 903,
  STARKNET_MAINNET = 1001,
  STARKNET_GOERLI = 1002,
  STARKNET_SEPOLIA = 1003,
  BASE_MAINNET = 1101,
  BASE_GOERLI = 1102,
  BASE_SEPOLIA = 1103,
  ZKSYNC_MAINNET = 1201,
  ZKSYNC_SEPOLIA = 1202,
  ZORA_MAINNET = 1301,
  ZORA_SEPOLIA = 1302,
  FRAX_MAINNET = 1401,
  FRAX_SEPOLIA = 1402,
  BNB_MAINNET = 1501,
  BNB_TESTNET = 1502,
}
